import {UserVerify} from "./model/user-verify";
import {ChallengeResultTaskDto} from "./model/user-response-dto";
import {Config} from "../../config";

export class ApiService {

  public static async verifyUser(config: Config, body: UserVerify, signal?: AbortSignal): Promise<Response> {

    const url = `${config.trustcaptchaApi}/verifications?siteKey=${config.sitekey}`;

    return await this.post(url, body, signal);
  }

  public static async sendSolutions(config: Config, verificationId: string, startSolvingTimestamp: string, solvedTimestamp: string, tasks: ChallengeResultTaskDto[], honeypotField: string, userEvents: any[], signal?: AbortSignal): Promise<Response> {

    const url = `${config.trustcaptchaApi}/verifications/${verificationId}/challenges`;
    const body = { startSolvingTimestamp, solvedTimestamp, tasks, honeypotField, userEvents };

    return await this.post(url, body, signal);
  }

  private static async post(url = '', body: any = {}, signal?: AbortSignal): Promise<Response> {

    return await fetch(url, {
      method: 'POST',
      mode: 'cors',
      cache: 'no-cache',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json'
      },
      redirect: 'follow',
      referrerPolicy: 'no-referrer',
      body: JSON.stringify(body),
      signal,
    });
  }
}
